import { ActionTree } from 'vuex';
import { URLState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { LoadStateFromURLAction } from './actions/load-state-from-url.action';
import { StoreURLAction } from './actions/store-url.action';

export const URL_ACTIONS: ActionTree<URLState, RootStoreState> = {
  ...new StoreURLAction().actions,
  ...new LoadStateFromURLAction().actions
};
